<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="关键词">
        <el-input
          v-model="searchModel.keyword"
          placeholder="请输入名称或税号"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ivName" label="抬头名称" min-width="180" header-align="center"></el-table-column>
        <el-table-column prop="type" label="抬头类型" header-align="center"></el-table-column>
        <el-table-column prop="ivNo" label="单位税号" align="center"></el-table-column>
        <el-table-column prop="ivAddress" label="注册地址" align="center"></el-table-column>
        <el-table-column prop="ivPhone" label="注册电话" align="center"></el-table-column>
        <el-table-column prop="ivBank" label="开户银行" align="center"></el-table-column>
        <el-table-column prop="ivAccount" label="银行账号" align="center"></el-table-column>

        <el-table-column label="操作" width="200" align="center">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑 -->
    <InvoiceInfoEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <!-- 详情 -->
    <InvoiceInfoDetail :visible.sync="detailVisible" :activeId="activeRowId" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import InvoiceInfoEdit from './components/InvoiceInfoEdit';
import InvoiceInfoDetail from './components/InvoiceInfoDetail';

import { getMyInvoiceTitleAllList } from '@/api/invoice';

export default {
  components: { TableHeader, InvoiceInfoEdit, InvoiceInfoDetail },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        keyword: '',
        dateRange: []
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      // 弹窗
      activeRowId: null,
      activeRowInfo: {},
      detailVisible: false,
      editVisible: false,
      tagPrintVisible: false,
      adjustVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const { data } = await getMyInvoiceTitleAllList(this.searchModel);
      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .warning-row {
    .el-table__cell {
      position: relative;
    }
  }
  .logo-box {
    padding-left: 12px;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
